import classNames from "classnames";
import QuillEditor from "components/QuillEditor/QuillEditor";
import Quill from "quill";
import { useEffect, useRef, useState } from "react";
import { parseRichText } from "util/richText";

type RichTextViewProps = {
  value?: string | null;
  className?: string;
  hasLegacyMarkdown?: boolean;
};

const VIEW_CLASSES =
  "[&_.ql-container]:!t-border-none [&_.ql-container]:![font:inherit] [&_.ql-editor]:![font:inherit] [&_.ql-editor]:!t-p-0 [&_.ql-editor]:!t-overflow-visible [&_.ql-editor_ol]:!t-pl-0";

export const RichTextView = ({
  value,
  className,
  hasLegacyMarkdown = false,
}: RichTextViewProps) => {
  const quillRef = useRef<Quill | null>(null);
  const [defaultValue] = useState(() =>
    parseRichText(value, hasLegacyMarkdown)
  );

  useEffect(() => {
    quillRef.current?.setContents(parseRichText(value, hasLegacyMarkdown));
  }, [value, hasLegacyMarkdown]);

  return (
    <QuillEditor
      className={classNames(VIEW_CLASSES, className)}
      parentRef={quillRef}
      defaultValue={defaultValue}
      theme="bubble"
      toolbar={false}
      initReadOnly
      readOnly
    />
  );
};
